module.exports = __webpack_public_path__ + "img/eye-01.8c16708c.svg";